import { api } from '@services';
import Tag, { ITag, ITagApiModel } from '@models/Tag.model';

interface IRemoveTag {
  equipmentId?: string;
  softwareId?: string;
  miscellaneousId?: string;
  studioServiceId?: string;
  tagsIds: string[];
}

const removeTags = async (data: IRemoveTag): Promise<ITag[]> => {
  const { data: tags } = await api.put<ITagApiModel[]>('/tags/removes', data);
  return Tag.arrayFromApiModel(tags);
};

export { removeTags };
